import React, { useEffect, useState } from "react";
import bannerImg from "../assets/banner-250422.png";

import { Box } from "../../shared/components/ui/chakra";
import { BoxProps, CloseButton, Flex, Grid, GridItem, Image, Show } from "@chakra-ui/react";

const EventBanner = (props?: BoxProps) => {
  const [isShow, setIsShow] = useState(false);

  const closeButtonStyle = {
    border: "2px solid #41AA92",
    bgColor: "white",
    color: "primary",
  };

  useEffect(() => {
    const showEventModal =
      (window.sessionStorage.getItem("show-event-popup") ?? "1") == "1";
    setIsShow(showEventModal);
  }, []);

  return (
    <>
      {isShow && (
        <Show above="lg">
          <Box
            position="fixed"
            zIndex={200}
            right={4}
            bottom={4}
            w={96}
            maxW="60%"
            {...props}
          >
            <Flex justifyContent="flex-end">
              <CloseButton
                position="relative"
                size="lg"
                top={{ base: 0, md: 4 }}
                zIndex={20}
                {...closeButtonStyle}
                onClick={(e) => {
                  setIsShow(false);
                  window.sessionStorage.setItem("show-event-popup", "0");
                  e.stopPropagation();
                }}
              />
            </Flex>
            <Grid cursor="pointer" position="relative" rounded="lg">
              <GridItem
                gridColumnStart={1}
                gridRowStart={1}
                zIndex={10}
                as="a"
                href="https://aloop.jp/announcements/20250325_140806"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={bannerImg} />
              </GridItem>
              <GridItem
                gridColumnStart={1}
                gridRowStart={1}
                h="80%"
                alignSelf="flex-end"
                shadow="xl"
                rounded="xl"
              />
            </Grid>
          </Box>
        </Show>
      )}
    </>
  );
};

export default EventBanner;
